import {
  Box,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { WebServiceLayerType } from "shared/common/stores/sidebarStore";

const GeoserverOptions = ({
  webServiceLayer,
  useOldConnection,
}: {
  webServiceLayer: WebServiceLayerType;
  useOldConnection: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection={"column"} gap={2}>
      <Box display="flex" gap={2}>
        <TextField
          label={t("add_layer.username")}
          variant="outlined"
          defaultValue={
            (useOldConnection &&
              webServiceLayer?.source_options?.generatetoken?.username) ||
            ""
          }
          size="small"
          sx={{ width: { xs: "calc(50% - 8px)", md: "calc(30% - 12px)" } }}
          onChange={(event) => {
            if (!webServiceLayer.source_options) {
              webServiceLayer.source_options = {};
            }
            if (!webServiceLayer.source_options.generatetoken) {
              webServiceLayer.source_options.generatetoken = {
                username: event.target.value,
                password: "",
              };
              return;
            }
            webServiceLayer.source_options.generatetoken.username =
              event.target.value;
          }}
        />
        <TextField
          label={t("add_layer.password")}
          variant="outlined"
          type="password"
          defaultValue={
            (useOldConnection &&
              webServiceLayer?.source_options?.generatetoken?.password) ||
            ""
          }
          size="small"
          sx={{ width: { xs: "calc(50% - 8px)", md: "calc(30% - 12px)" } }}
          onChange={(event) => {
            if (!webServiceLayer.source_options) {
              webServiceLayer.source_options = {};
            }
            if (!webServiceLayer.source_options.generatetoken) {
              webServiceLayer.source_options.generatetoken = {
                username: "",
                password: event.target.value,
              };
              return;
            }
            webServiceLayer.source_options.generatetoken.password =
              event.target.value;
          }}
        />
      </Box>
      <Box display="flex" gap={2}>
        <TextField
          label={t("add_layer.featureNS")}
          variant="outlined"
          defaultValue={
            (useOldConnection && webServiceLayer?.source_options?.featureNS) ||
            ""
          }
          size="small"
          sx={{ width: { xs: "calc(50% - 8px)", md: "calc(60% - 8px)" } }}
          onChange={(event) => {
            if (!webServiceLayer.source_options) {
              webServiceLayer.source_options = {};
            }
            webServiceLayer.source_options.featureNS = event.target.value;
          }}
        />
        <TextField
          label={t("add_layer.version")}
          variant="outlined"
          defaultValue={
            (useOldConnection && webServiceLayer?.source_options?.version) || ""
          }
          size="small"
          sx={{ width: { xs: "calc(50% - 8px)", md: "calc(40% - 8px)" } }}
          onChange={(event) => {
            if (!webServiceLayer.source_options) {
              webServiceLayer.source_options = {};
            }
            webServiceLayer.source_options.version = event.target.value;
          }}
        />
      </Box>
      <FormGroup sx={{ width: "40%" }}>
        <FormControlLabel
          onChange={(event, checked: boolean) => {
            if (!webServiceLayer.source_options) {
              webServiceLayer.source_options = {};
            }
            webServiceLayer.source_options.use_post = checked;
          }}
          control={
            <Switch
              defaultChecked={
                (useOldConnection &&
                  webServiceLayer?.source_options?.use_post) ||
                false
              }
            />
          }
          label={t("add_layer.switch_button_1")}
        />
        <FormControlLabel
          onChange={(event, checked: boolean) => {
            if (!webServiceLayer.source_options) {
              webServiceLayer.source_options = {};
            }
            webServiceLayer.source_options.withCredentials = checked;
          }}
          control={
            <Switch
              defaultChecked={
                useOldConnection &&
                webServiceLayer?.source_options?.withCredentials
                  ? webServiceLayer.source_options.withCredentials
                  : useOldConnection
                    ? false
                    : true
              }
            />
          }
          label={t("add_layer.switch_button_2")}
        />
      </FormGroup>
    </Box>
  );
};
export default GeoserverOptions;
